import React from "react";
import "./AboutHero.css";

import heroTrade from "../../images/heroTrade.webp";
import chartThree from "../../images/Chart 3.webp";

const truthPoints = [
  "First principles",
  "Risk before reward",
  "Process over hype",
];

const contactItems = [
  {
    id: "campus",
    label: "Campus",
    value: "012 051 3483",
    href: "tel:0120513483",
  },
  {
    id: "student-support",
    label: "Student Support",
    value: "+27 82 732 3216",
    href: "tel:+27827323216",
  },
  {
    id: "email",
    label: "Email",
    value: "info@tpc.training",
    href: "mailto:info@tpc.training",
  },
  {
    id: "location",
    label: "Campus Location",
    value: "Floor 2, Landmark Building, 13 Umgazi Rd, Menlo Park, Pretoria, 0081",
  },
];

const marketCandles = [
  "green",
  "green",
  "red",
  "green",
  "red",
  "green",
  "green",
  "red",
  "green",
  "green",
];

const truthTrends = ["gold", "green", "red"];

function AboutHero() {
  return (
    <section
      className="trpc-aboutLanding"
      aria-labelledby="trpc-aboutHero-title"
    >
      <div className="trpc-aboutLanding-frame">
        <div className="trpc-aboutLanding-art" aria-hidden="true">
          <img
            className="trpc-aboutLanding-bgImage"
            src={heroTrade}
            alt=""
            decoding="async"
            fetchPriority="high"
          />

          <img
            className="trpc-aboutLanding-chart"
            src={chartThree}
            alt=""
            decoding="async"
            fetchPriority="high"
          />

          <div className="trpc-aboutLanding-marketLayer">
            <span className="trpc-aboutLanding-priceLine" />

            <div className="trpc-aboutLanding-candleGroup">
              {marketCandles.map((trend, index) => (
                <span
                  key={`${trend}-${index}`}
                  className="trpc-aboutLanding-candle"
                  data-trend={trend}
                />
              ))}
            </div>
          </div>

          <div className="trpc-aboutLanding-overlay" />
        </div>

        <div className="trpc-aboutLanding-content">
          <div className="trpc-aboutLanding-copy">
            <div className="trpc-aboutLanding-kicker">
              About Trade Performance Centre
            </div>

            <h1 id="trpc-aboutHero-title" className="trpc-aboutLanding-title">
              <span>No shortcuts.</span>
              <span>Real trading.</span>
            </h1>

            <p className="trpc-aboutLanding-lead">
              This is not tips, hacks or quick-profit fantasy. We teach market
              structure, risk and execution from first principles — because
              shortcuts blow accounts.
            </p>

            <ul
              className="trpc-aboutLanding-truthList"
              aria-label="TPC trading education principles"
            >
              {truthPoints.map((point, index) => (
                <li
                  key={point}
                  data-trend={truthTrends[index] || "green"}
                >
                  <span>{point}</span>
                </li>
              ))}
            </ul>

            <div className="trpc-aboutLanding-actions">
              <a
                className="trpc-aboutLanding-btn trpc-aboutLanding-candleBtn trpc-aboutLanding-candleBtn--primary"
                href="https://andus.co.za/trade-register"
                target="_blank"
                rel="noopener noreferrer"
                data-candle="green"
              >
                <span>Apply Online</span>
              </a>

              <a
                className="trpc-aboutLanding-btn trpc-aboutLanding-candleBtn trpc-aboutLanding-candleBtn--secondary"
                href="#trpc-about-method"
                data-candle="red"
              >
                <span>See Our Method</span>
              </a>
            </div>
          </div>

          <aside
            className="trpc-aboutLanding-focusCard"
            aria-label="TPC trading education standard and contact information"
          >
            <div className="trpc-aboutLanding-focusTop">
              <span className="trpc-aboutLanding-focusLabel">
                The Hard Truth
              </span>

              <div
                className="trpc-aboutLanding-focusTicker"
                aria-hidden="true"
              >
                {marketCandles.slice(0, 6).map((trend, index) => (
                  <span
                    key={`focus-${trend}-${index}`}
                    className="trpc-aboutLanding-miniCandle"
                    data-trend={trend}
                  />
                ))}
              </div>
            </div>

            <strong>You cannot fake fundamentals.</strong>

            <p>
              Learn why price moves, how risk works and what your plan demands
              before you trade size.
            </p>

            <div
              className="trpc-aboutLanding-contactPanel"
              aria-label="Contact information"
            >
              <span className="trpc-aboutLanding-contactEyebrow">
                Contact
              </span>

              <div className="trpc-aboutLanding-contactList">
                {contactItems.map((item) => (
                  <div
                    key={item.id}
                    className="trpc-aboutLanding-contactItem"
                  >
                    <span className="trpc-aboutLanding-contactLabel">
                      {item.label}
                    </span>

                    {item.href ? (
                      <a
                        className="trpc-aboutLanding-contactValue"
                        href={item.href}
                      >
                        {item.value}
                      </a>
                    ) : (
                      <address className="trpc-aboutLanding-contactValue">
                        {item.value}
                      </address>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </aside>
        </div>
      </div>

      <div
        className="trpc-aboutLanding-standardStrip"
        aria-label="TPC trading standard"
      >
        <div className="trpc-aboutLanding-standardFrame">
          <div className="trpc-aboutLanding-standardContent">
            <div className="trpc-aboutLanding-standardBadge">
              <span className="trpc-aboutLanding-standardBadgeMain">No</span>
              <span className="trpc-aboutLanding-standardBadgeSub">
                Shortcuts
              </span>
            </div>

            <div className="trpc-aboutLanding-standardCopy">
              <p className="trpc-aboutLanding-standardKicker">
                The TPC Standard
              </p>

              <h2 className="trpc-aboutLanding-standardTitle">
                Cheap tricks are expensive.
              </h2>

              <p className="trpc-aboutLanding-standardText">
                YouTube has shortcuts. The market has consequences. Learn the
                fundamentals if you want to last.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AboutHero;